module.exports = __webpack_public_path__ + "static/media/mw.9290fe20.png";